import React from 'react';
import { motion } from 'framer-motion';
import { Sun, Moon, Monitor } from 'lucide-react';

const OPTIONS = [
  { id: 'light',  icon: Sun,     label: 'Light' },
  { id: 'system', icon: Monitor, label: 'System' },
  { id: 'dark',   icon: Moon,    label: 'Dark' },
];

export default function ThemeToggle({ value, onChange }) {
  return (
    <div style={{
      display: 'flex', gap: 2,
      background: 'var(--bg-4)',
      border: '1px solid var(--border)',
      borderRadius: 10, padding: 3,
    }}>
      {OPTIONS.map(({ id, icon: Icon, label }) => {
        const active = value === id;
        return (
          <motion.button
            key={id}
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
            onClick={() => onChange(id)}
            title={label}
            style={{
              display: 'flex', alignItems: 'center', justifyContent: 'center',
              width: 28, height: 28, borderRadius: 7, border: 'none',
              cursor: 'pointer', fontFamily: 'inherit',
              background: active ? 'var(--bg-2)' : 'transparent',
              color: active ? 'var(--text-primary)' : 'var(--text-muted)',
              boxShadow: active ? '0 1px 4px rgba(0,0,0,0.15)' : 'none',
              transition: 'background 0.15s, color 0.15s',
            }}
          >
            <Icon size={13} />
          </motion.button>
        );
      })}
    </div>
  );
}
